if (!customElements.get('tabing-collections-tabs')) {
  class TabingCollectionsTabs extends HTMLElement {
    constructor() {
      super();
      this._onBlockSelect = null;
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.buttons = Array.from(this.querySelectorAll('.collection-tabs__list-link'));
        this.slider = this.querySelector('[data-tabing-grid]');
        this.themeScroll = this.querySelector('theme-scroll');

        if (!this.slider || this.buttons.length === 0) return;

        this.collectionMap = new Map();
        this.slider.querySelectorAll('[data-collection]').forEach((item) => {
          const handle = item.dataset.collection;
          if (!this.collectionMap.has(handle)) {
            this.collectionMap.set(handle, []);
          }
          this.collectionMap.get(handle).push(item);
        });

        this.addEventListener('click', (event) => {
          const button = event.target.closest('.collection-tabs__list-link');
          if (!button) return;
          event.preventDefault();
          const index = this.buttons.indexOf(button);
          if (index === -1) return;
          this.toggleButtons(index);
          this.toggleCollection(button.dataset.collection);
        });

        if (Shopify.designMode) {
          this._onBlockSelect = (event) => {
            const button = event.target.closest('.collection-tabs__list-link');
            if (button) {
              button.click();
            }
          };
          this.addEventListener('shopify:block:select', this._onBlockSelect);
        }

        this.toggleCollection(this.buttons[0].dataset.collection);
      });
    }

    disconnectedCallback() {
      if (this._onBlockSelect) {
        this.removeEventListener('shopify:block:select', this._onBlockSelect);
      }
    }

    toggleButtons(index) {
      this.buttons.forEach((button, i) => {
        button.classList.toggle('active', i === index);
      });
    }

    toggleCollection(handle) {
      if (!this.slider || !handle) return;

      this.slider.querySelectorAll('[data-collection]').forEach((item) => {
        item.classList.remove('carousel__slide');
      });

      const activeItems = this.collectionMap.get(handle);
      if (activeItems) {
        activeItems.forEach((item) => {
          item.classList.add('carousel__slide');
        });
      }

      if (!this.themeScroll || typeof this.themeScroll.init !== 'function') return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.themeScroll.init();
          const inner = this.themeScroll.querySelector('.theme-scroll--inner');
          if (inner) {
            inner.scrollTo({ top: 0, left: 0 });
          }
        });
      });
    }
  }

  customElements.define('tabing-collections-tabs', TabingCollectionsTabs);
}